<template>
  <el-dialog
    :visible="true"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    class="bulk-call-wrap"
  >
    <ContentHeader
      slot="title"
      :title="$t('global.update')"
    />

    <BulkCall
      ref="refBulk"
      :function="genericBulkFunction"
      :arguments="genericBulkArguments"
      @completed="bulkCompleted"
    />

    <el-row
      type="flex"
      justify="end"
      class="form__buttons-row"
    >
      <el-col :span="24">
        <el-button
          type="primary"
          @click.prevent="close"
        >
          {{ $t('global.close') }}
        </el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  import BulkCall from '@/components/BulkCall.vue';
  import ContentHeader from '@/components/ContentHeader.vue';

  export default {
    name: 'ProgressDialog',
    components: {
      BulkCall,
      ContentHeader,
    },
    props: {
      function: { type: Function, required: true },
      arguments: { type: Array, required: true },
      visible: { type: Boolean },
    },
    data() {
      return {
        apiCallStarted: false,
        apiCallEnded: false,
      };
    },
    computed: {
      genericBulkFunction() {
        return this.function;
      },
      genericBulkArguments() {
        return this.arguments;
      },
    },
    created() {
      this.$nextTick(() => {
        this.apiCallStarted = true;
        this.$refs.refBulk.run();
      });
    },
    methods: {
      bulkCompleted(errors) {
        this.apiCallEnded = true;
        if (!errors) {
          this.close();
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('global.success'),
          });
        }
      },
      close() {
        this.$emit('dialogClose', { success: true });
      },
    },
  };
</script>

<style lang="scss">
  .bulk-call-wrap {
    .el-dialog {
      width: 30%;
    }
  }
</style>
